// types
import { Contract } from '../../../../@types';

// l18n
import { TFunction } from 'i18next';

// mui
import { Grid, Typography } from '@mui/material';

// table
import { TableHeader } from '../../../ui/Table/Table';

// ui
import { Amount } from '../../../ui/Amount/Amount';
import { Time } from '../../../ui/Time/Time';

// props
export interface GetHeadersProps {
	t: TFunction<'translation', undefined>;
}

export const getHeaders = ({ t }: GetHeadersProps): TableHeader[] => {
	return [
		{
			label: t('contract'),
			render: (num: string) => {
				return <Typography fontWeight={600}>{num}</Typography>;
			},
			value: 'num',
		},
		{
			label: t('amounts'),
			value: 'amounts',
			render: (amounts: Contract['amounts'], header: TableHeader, contract: Contract) => {
				return amounts && amounts.length > 0 ? (
					<Grid container spacing={1}>
						{amounts.map((amount, index) => (
							<Grid item key={amount.id || index}>
								<Amount currency={amount.currency} value={amount.amount} />
							</Grid>
						))}
					</Grid>
				) : (
					t('na')
				);
			},
		},
		{
			label: t('created'),
			render: (created: string) => {
				return <Time date={new Date(created)} />;
			},
			value: 'created',
		},
	];
};
